module.exports = __webpack_public_path__ + "static/media/chaturbate.0c09924e.png";